import { Button, Skeleton } from "@netfront/ui-library";
import { ContinueModuleCardProps } from "./ContinueModuleCard.interfaces";
import { Card, ProgressCircle } from "@/components";
import { getValidClassNames } from "@/utils";

export const ContinueModuleCard = ({ action, isCompleted, isLoading, percentageComplete = 0, subTitle, title }: ContinueModuleCardProps) => {
  return isLoading ? (
    <Skeleton
      baseColor="var(--grey-300)"
      borderRadius='20px'
      height='100%'
    />
    ) : (
      <Card additionalClassNames="grid md:grid-cols-[auto_1fr] gap-4 items-start md:flex-row border-green-400 shadow-none c-spotlight--quick-access">
        {isCompleted ? (
          <img src="/images/achievement-icon.svg" alt="Trophy" />
        ) : (
          <ProgressCircle 
            styles={{
              root: {
                backgroundColor: percentageComplete === 100 ? 'var(--green-400)' : 'var(--black)',
              },
              path: {
                stroke: 'var(--green-400)',
              },
              text: {
                fill: 'var(--white)',
              }
            }}
            percentageCompleted={percentageComplete}
          />
        )}

        <div>
          {subTitle && (
            <p className="h5 mb-1">{subTitle}</p>
          )}

          <p 
            className={getValidClassNames({
              "h3": !isCompleted,
              "h4": isCompleted
            })}
          >{title}</p>

          {action && (
            <Button
              additionalClassNames="mt-4"
              {...action}
            />
          )}
        </div>
      </Card>
    )
};